//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
//#endregion

/**
 * 안전보건교육 - 교육관리(교육별) (SAT_BASIC_04) 전용 로직
 * other 케이스에서 사용
 */

// 안전보건교육 - 교육관리(교육별) 인쇄 함수
export const PrintLogic1 = async (
  documentData, // 선택된 항목 데이터 (사용하지 않지만 시그니처 통일을 위해 유지)
  dispatch,
  setLoading,
  rowData1, // 전체 리스트
  searchRef
) => {
  setLoading(true);

  try {
    if (!rowData1 || rowData1.length === 0) {
      dispatch(
        showSnackbar({
          message: '인쇄할 데이터가 없습니다.',
          type: 'warning',
        })
      );
      return null;
    }

    // HeaderData 설정
    const headerData = {
      YEAR: searchRef?.current?.currentYear,
    };

    // TableData 매핑 (레포트 양식에 맞게)
    const tableData = rowData1
      .filter((row) => !row.deleteYn) // 삭제된 행 제외
      .map((row, index) => {
        // 진행율 계산 (이수자 / 교육대상자 * 100)
        const targetCount = Number(row.sheTargetCount) || 0;
        const completerCount = Number(row.sheGraduate) || 0;
        let progressRate = 0;
        if (targetCount > 0 && completerCount > 0) {
          progressRate = (completerCount / targetCount) * 100;
        }
        const progressRateFormatted = Math.round(progressRate * 100) / 100; // 소수점 2자리

        return {
          NO: index + 1,
          SHE_NM: row.sheNm || '', // 교육명(노입력)
          SHE_PERIOD: row.shePeriod || '', // 기간(텍스트)
          SHE_TARGET_COUNT: row.sheTargetCount || 0, // 교육대상자 (인원수)
          SHE_GRADUATE: row.sheGraduate || 0, // 이수자 (인원수)(숫자)
          GRADUATE_RATE: progressRateFormatted, // 진행율(%) (자동계산)
        };
      });

    const printData = {
      FileName: 'TRA_BASIC_06',
      HeaderData: JSON.stringify(headerData),
      TableData: JSON.stringify(tableData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    // response.data가 blob인 경우 그대로 반환
    if (response.data instanceof Blob) {
      return response.data;
    }
    // response.data가 다른 형태인 경우 blob으로 변환
    else if (response.data) {
      return new Blob([response.data], { type: 'application/pdf' });
    } else {
      console.error('PrintLogic1: 응답 데이터가 없습니다.');
      return null;
    }
  } catch (e) {
    console.error(e);
    dispatch(showSnackbar({ message: e.message, type: 'error' }));
    return null;
  } finally {
    setLoading(false);
  }
};

